import { render, staticRenderFns } from "./lstUserRole.vue?vue&type=template&id=c7111494&"
import script from "./lstUserRole.vue?vue&type=script&lang=js&"
export * from "./lstUserRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports